import React from "react";
//Limitless imports
import { useNotificationContext } from "@limitless/common/hooks/notification/NotificationContext";
import { fetchPendingQuestions } from "../../../portal";
const PENDING_QUESTIONS_INITIAL_STATE = {
  loading: false,
  history: [],
  filtered: [],
  hasError: false
};
const PENDING_FILTERS_INITIAL_STATE = {
  selectedGroups: [],
  responded: false,
  forwarded: false,
  reviewed: false,
  inProgress: null,
  awaitingPayment: null
};
const UPDATE_PENDING_QUESTIONS = "update-pending-questions";
const RESET_PENDING_QUESTIONS = "reset-pending-questions";
const SET_LOAD_PENDING_QUESTIONS = "load-pending-questions";
const pendingQuestionsReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_PENDING_QUESTIONS:
      {
        return {
          ...state,
          ...action.payload
        };
      }
    case SET_LOAD_PENDING_QUESTIONS:
      return {
        ...state,
        loading: true
      };
    case RESET_PENDING_QUESTIONS:
      return PENDING_QUESTIONS_INITIAL_STATE;
    default:
      throw new Error(`Unsupported pending questions action type ${action.tyoe}`);
  }
};
const UPDATE_PENDING_FILTERS = "update-pending-filters";
const RESET_PENDING_FILTERS = "reset-pending-filters";
const pendingQuestionsFilterReducer = (state, action) => {
  switch (action.type) {
    case UPDATE_PENDING_FILTERS:
      return {
        ...state,
        ...action.payload
      };
    case RESET_PENDING_FILTERS:
      return PENDING_FILTERS_INITIAL_STATE;
    default:
      throw new Error(`Unsupported pending questions action type ${action.tyoe}`);
  }
};
export const useExpertPendingQuestions = () => {
  const [pendingQuestions, dispatchQuestions] = React.useReducer(pendingQuestionsReducer, PENDING_QUESTIONS_INITIAL_STATE);
  const [pendingFilters, dispatchFilters] = React.useReducer(pendingQuestionsFilterReducer, PENDING_FILTERS_INITIAL_STATE);
  const [availableGroups, setAvailableGroups] = React.useState([]);
  const {
    addFailureNotification
  } = useNotificationContext();
  const filterExists = pendingFilters.selectedGroups.length > 0 || pendingFilters.responded || pendingFilters.forwarded || pendingFilters.reviewed || pendingFilters.inProgress || pendingFilters.awaitingPayment;
  React.useEffect(() => {
    applyFilters();
  }, [pendingFilters]);
  React.useEffect(() => {
    if (pendingQuestions.history.length > 0 && availableGroups.length === 0) {
      const groupNames = [];
      const groups = pendingQuestions.history.map(item => {
        if (!groupNames.includes(item.groupName)) {
          groupNames.push(item.groupName);
          return {
            label: item.groupName,
            value: item.groupName
          };
        }
        return null;
      });
      setAvailableGroups(groups.filter(i => i));
    }
  }, [pendingQuestions]);
  const updatePendingFilters = values => {
    dispatchFilters({
      type: UPDATE_PENDING_FILTERS,
      payload: {
        ...pendingFilters,
        ...values
      }
    });
  };
  const clearPendingFilters = () => {
    dispatchFilters({
      type: RESET_PENDING_FILTERS
    });
    dispatchQuestions({
      type: RESET_PENDING_QUESTIONS
    });
    loadExpertPendingQuestions();
  };
  const applyFilters = () => {
    dispatchQuestions({
      type: UPDATE_PENDING_QUESTIONS,
      payload: {
        loading: true
      }
    });
    const filteredHistory = pendingQuestions.history.filter(item => {
      const groupHasSelection = pendingFilters.selectedGroups.length !== 0;
      const isGroupSelected = groupHasSelection && pendingFilters.selectedGroups.map(i => i.value).includes(item.groupName);
      const rewardTypeHasSelection = pendingFilters.responded === true || pendingFilters.forwarded === true || pendingFilters.reviewed === true;
      const isRewardTypeSelected = pendingFilters.responded === true && item.type === "responded" || pendingFilters.forwarded === true && item.type === "escalated" || pendingFilters.reviewed === true && item.type === "reviewed";
      const statusHasSelection = pendingFilters.awaitingPayment || pendingFilters.inProgress;
      const isStatusSelcted = pendingFilters.awaitingPayment && item.lifecycleState === "resolved" || pendingFilters.inProgress && item.lifecycleState !== "resolved";
      let returnItem = true;
      if (groupHasSelection && !isGroupSelected) {
        returnItem = false;
      }
      if (rewardTypeHasSelection && !isRewardTypeSelected) {
        returnItem = false;
      }
      if (statusHasSelection && !isStatusSelcted) {
        returnItem = false;
      }
      return returnItem;
    });
    dispatchQuestions({
      type: UPDATE_PENDING_QUESTIONS,
      payload: {
        ...pendingQuestions,
        filtered: filteredHistory,
        loading: false
      }
    });
  };
  const loadExpertPendingQuestions = () => {
    dispatchQuestions({
      type: SET_LOAD_PENDING_QUESTIONS,
      payload: {
        ...pendingQuestions
      }
    });
    fetchPendingQuestions(response => {
      if (!response.hasError) {
        dispatchQuestions({
          type: UPDATE_PENDING_QUESTIONS,
          payload: {
            ...pendingQuestions,
            history: response,
            filtered: response,
            hasError: false,
            loading: false
          }
        });
      } else {
        addFailureNotification("Failed to find pending fee allocation tasks");
        dispatchQuestions({
          type: UPDATE_PENDING_QUESTIONS,
          payload: {
            ...pendingQuestions,
            history: [],
            hasError: true,
            loading: false
          }
        });
      }
    });
  };
  return {
    loadExpertPendingQuestions,
    pendingQuestions,
    filterExists,
    availableGroups,
    pendingFilters,
    updatePendingFilters,
    clearPendingFilters
  };
};